import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from '../../services/notification.service';
import { UserInfo } from '../../dtos/user-info';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  userInfo: UserInfo | null = null;
  private profileSub?: Subscription;

  constructor(
    public authService: AuthService,
    private profileService: ProfileService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    // subscribe to profile changes so logout/login updates are reflected
    this.profileSub = this.profileService.currentUser$.subscribe((user) => {
      this.userInfo = user;
      // Start/stop notification polling based on login status
      if (user) {
        this.notificationService.startPolling();
      } else {
        this.notificationService.stopPolling();
      }
    });

    // if already logged in, ensure we have fetched the current user
    if (this.authService.isLoggedIn()) {
      this.profileService.getCurrentUser().subscribe({
        next: (user) => (this.userInfo = user),
        error: () => {
          console.error('Error loading user profile for header');
          this.userInfo = null;
        },
      });
    }
  }

  ngOnDestroy(): void {
    this.profileSub?.unsubscribe();
    this.notificationService.stopPolling();
  }

  getInitials(): string {
    return this.userInfo?.initials || 'U';
  }

  canManageUsers(): boolean {
    const role = this.userInfo?.role || this.authService.getUserRole();
    return role === 'ADMIN' || role === 'SUPER_ADMIN';
  }

  isSuperAdmin(): boolean {
    const role = this.userInfo?.role || this.authService.getUserRole();
    return role === 'SUPER_ADMIN';
  }
}
